export { default as NutritionInformation } from './nutrition-information';
